// src/pages/Admin/AdminLayout.jsx
import React, { useState } from 'react';
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth.js';

export const AdminLayout = () => {
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  // Проверка прав доступа
  if (!isAuthenticated || (user?.role !== 'admin' && user?.role !== 'manager')) {
    navigate('/');
    return null;
  }

  const menuItems = [
    { path: '/admin', label: '📊 Дашборд', icon: '📊' },
    { path: '/admin/products', label: '📦 Товары', icon: '📦' },
    { path: '/admin/categories', label: '📁 Категории', icon: '📁' },
    { path: '/admin/orders', label: '📋 Заказы', icon: '📋' },
    { path: '/admin/blog', label: '✍️ Блог', icon: '✍️' },
    { path: '/admin/cases', label: '🏆 Кейсы', icon: '🏆' },
    { path: '/admin/users', label: '👥 Пользователи', icon: '👥' },
    { path: '/admin/support', label: '🆘 Поддержка', icon: '🆘' },
    // ⚠️ Пункт «Калькуляторы» убран 2026-10-10 вместе с таблицей
    //    `calculators` (страницы AdminCalculator/AdminCalculatorForm удалены).
    //    Источник цены товара теперь настраивается в карточке товара:
    //    поле «Источник цены» (фиксированная / NORRAN).
  ];

  return (
    <div style={{ display: 'flex', minHeight: '100vh', backgroundColor: 'rgb(var(--c-surface-2))' }}>
      {/* Sidebar */}
      <aside style={{
        width: isSidebarOpen ? '260px' : '60px',
        backgroundColor: 'rgb(var(--c-text))',
        color: 'rgb(var(--c-on-accent))',
        transition: 'width 0.3s',
        overflow: 'hidden',
        position: 'fixed',
        top: 0,
        left: 0,
        bottom: 0,
        zIndex: 100,
      }}>
        <div style={{
          padding: '20px 16px',
          borderBottom: '1px solid rgba(255,255,255,0.1)',
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
        }}>
          <button
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            style={{
              background: 'none',
              border: 'none',
              color: 'rgb(var(--c-on-accent))',
              fontSize: '20px',
              cursor: 'pointer',
            }}
          >
            {isSidebarOpen ? '◀' : '▶'}
          </button>
          {isSidebarOpen && (
            <span style={{ fontSize: '18px', fontWeight: 700 }}>
              {/* Бренд владельца: «Студия Рекламы» (2026-10-07). Было «НОРРАН Admin» */}
              Студия Рекламы — Admin
            </span>
          )}
        </div>

        <nav style={{ padding: '16px 0' }}>
          {menuItems.map((item) => {
            const isActive = location.pathname === item.path || location.pathname.startsWith(item.path + '/');
            return (
              <Link
                key={item.path}
                to={item.path}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  padding: '12px 16px',
                  color: isActive ? '#205CA0' : '#A0A0A0',
                  backgroundColor: isActive ? 'rgba(32, 92, 160, 0.1)' : 'transparent',
                  textDecoration: 'none',
                  transition: 'all 0.2s',
                  borderLeft: isActive ? '3px solid rgb(var(--c-accent))' : '3px solid transparent',
                  whiteSpace: 'nowrap',
                }}
              >
                <span style={{ fontSize: '18px' }}>{item.icon}</span>
                {isSidebarOpen && (
                  <span style={{ fontSize: '14px', fontWeight: 500 }}>
                    {item.label}
                  </span>
                )}
              </Link>
            );
          })}
        </nav>
      </aside>

      {/* Main content */}
      <div style={{
        marginLeft: isSidebarOpen ? '260px' : '60px',
        flex: 1,
        transition: 'margin-left 0.3s',
        padding: '24px',
      }}>
        {/* Header */}
        <header style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '16px 24px',
          backgroundColor: 'rgb(var(--c-surface))',
          borderRadius: '12px',
          marginBottom: '24px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
        }}>
          <h1 style={{ fontSize: '24px', fontWeight: 700, color: 'rgb(var(--c-text))' }}>
            {menuItems.find(item => location.pathname === item.path || location.pathname.startsWith(item.path + '/'))?.label || 'Админ-панель'}
          </h1>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <span style={{ fontSize: '14px', color: 'rgb(var(--c-text-secondary))' }}>
              {user?.first_name} {user?.last_name}
            </span>
            <span style={{
              padding: '4px 12px',
              borderRadius: '100px',
              fontSize: '12px',
              fontWeight: 500,
              backgroundColor: user?.role === 'admin' ? '#205CA0' : '#4A6A8B',
              color: 'rgb(var(--c-on-accent))',
            }}>
              {user?.role === 'admin' ? 'Админ' : 'Менеджер'}
            </span>
          </div>
        </header>

        {/* Outlet */}
        <Outlet />
      </div>
    </div>
  );
};